import { atom } from 'recoil';

const languageStateKey = 'languageState';

export const languageState = atom({
  key: languageStateKey,
  default: 'enUS'
});
